// extracted by mini-css-extract-plugin
export default {"list":"productList_list__m6GRO","section":"productList_section__emdBf","column":"productList_column__qxYPy","columnOne":"productList_columnOne__WAdtz","row":"productList_row__wb1zA"};